<template>
  <div>
    <b-row>
      <b-col xl="3" lg="4" md="5">
        <FormCardProfileVue :loading="loading" />
      </b-col>
      <b-col xl="9" lg="8" md="7">
        <b-tabs>
          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')" :active="!$route.query.tab || $route.query.tab === 'pessoal'">
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Pessoal</span>
            </template>
            <FormAssocianteVue :loading="loading" />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_FINAN_CONSULTAR')" :active="$route.query.tab === 'financeiro'">
            <template #title>
              <feather-icon icon="DollarSignIcon" />
              <span>Financeiro</span>
            </template>
            <FormFinacialVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ATEND_CONSULTAR')">
            <template #title>
              <feather-icon icon="PhoneIcon" />
              <span>Atendimento</span>
            </template>
            <FormAttendanceVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="LinkIcon" />
              <span>Vinculos</span>
            </template>
            <FormLinkVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileTextIcon" />
              <span>Documentos</span>
            </template>
            <FormDocumentationsVue />
          </b-tab>

          <b-tab disabled>
            <template #title>
              <feather-icon icon="CalendarIcon" />
              <span>Eventos</span>
            </template>
            <FormEventsVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_CORE_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileIcon" />
              <span>Protocolos</span>
            </template>
            <FormProtocolVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_RELATORIO_CONSULTAR')">
            <template #title>
              <feather-icon icon="PrinterIcon" />
              <span>Relatorios</span>
            </template>
            <FormReportsVue />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { BRow, BCol, BTabs, BTab } from 'bootstrap-vue'

import mixinsGlobal from '@/mixins'
import FormAssocianteVue from '../associantes/forms/personal/FormAssociante.vue'
import FormFinacialVue from '../associantes/forms/finance/FormFinancial.vue'
import FormAttendanceVue from '../associantes/forms/attendance/FormAttendance.vue'
import FormDocumentationsVue from '../associantes/forms/documentations/FormDocumentations.vue'
import FormEventsVue from '../associantes/forms/events/FormEvents.vue'
import FormReportsVue from '../associantes/forms/report/GridReport.vue'
import FormLinkVue from '../associantes/forms/link/FormLink.vue'
import FormProtocolVue from '../associantes/forms/protocol/FormProtocol.vue'
import FormCardProfileVue from '../associantes/forms/personal/FormCardProfileAssociante.vue'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    FormAssocianteVue,
    FormFinacialVue,
    FormAttendanceVue,
    FormDocumentationsVue,
    FormEventsVue,
    FormReportsVue,
    FormCardProfileVue,
    FormLinkVue,
    FormProtocolVue
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      loading: true
    }
  },
  async mounted() {
    this.loading = true
    try {
      const response = await this.$store.dispatch(
        'associantesAdministrativeModule/getAssocianteID',
        this.$route.params.id
      )
      const objectAssociate = response.data

      if (objectAssociate.foto) {
        objectAssociate.foto = `data:image/jpeg;base64,${objectAssociate.foto}`
      }

      await this.$store.dispatch(
        'associantesAdministrativeModule/prepareToEditFullAssociante',
        objectAssociate
      )

      // Executa todas as chamadas de API em paralelo
      await Promise.all([
        this.$store.dispatch('associantesAdministrativeModule/loadComboGenero'),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboEstadoCivil'
        ),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboProfissoes'
        ),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboNaturalidades'
        ),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboNacionalidades'
        ),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboTypesRegister'
        ),
        this.$store.dispatch('associantesAdministrativeModule/loadComboUfs'),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboPrevidenciaSocial'
        ),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboTipoEndereco'
        ),
        this.$store.dispatch(
          'associantesAdministrativeModule/loadComboSituacaoRegistro'
        ),
        this.$store.dispatch('combosModule/loadComboFaixaContribuicao')
      ])

      this.loading = false
    } catch {
      this.MensagemError('Error', 'Erro ao carregar dados da tela!')
      this.loading = false
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
